import React from 'react';
import { Link } from 'react-router-dom';
import { FEATURE_SECTIONS } from './features';
import './Home.css';

function Home() {
    return (
        <div className="home">
            <h1>Kyber Drive</h1>
            <p className="home-lead">Everything in one place. Pick where you want to go.</p>
            {FEATURE_SECTIONS.map((section) => (
                <section key={section.title} className="home-section">
                    <h2>{section.title}</h2>
                    <ul className="home-grid">
                        {section.features.map(({ path, label, description, Icon }) => (
                            <li key={path}>
                                <Link to={path} className="home-tile">
                                    <span className="home-tile-icon" aria-hidden="true"><Icon /></span>
                                    <span className="home-tile-label">{label}</span>
                                    <span className="home-tile-desc">{description}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </section>
            ))}
        </div>
    );
}

export default Home;
